export const PAYMENTS_PATH = 'roster.data.payments';
export const PAYMENT_PATH = 'roster.data.payment';
export const PAYMENTS_MULTISIGNATORY_PATH = 'roster.data.multisignatory';
export const TRANSACTIONS_PATH = 'roster.data.transactions';

export const PAYMENT_BENF_ERROR_CODE = {
    BENF_SAME_ACCT : "503"
  }
  
export const PAYMENT_TYPE = {
  INTERNAL : "internal-payments",
  INTERNATIONAL : "international-payments",
  SEPA : "sepa-payments",
  DOMESTIC : "domestic-payments",
  DOMESTIC_UK: "domesticuk-payments"
}

export const PAYMENT_MODE = {
  SINGLE: 'SINGLE',
  MULTI: 'MULTI'
}

export const MODAL_TYPE = {
  CANCEL:'multisig_cancel',
  REJECT: 'multisig_reject',
  NONE: ''
}

export const PAYMENT_TYPE_KEY = {
  DOMESTIC: 'DOMESTIC_PAYMENT',
  SEPA: 'SEPA_PAYMENT',
  SWISS_QR_BILL: 'SWISS_QR_BILL_PAYMENT'
}

export const INTERNATIONAL_PAYMENT = "international"
export const TX_KEY_LENGTH = 4;
export const PAYMENT_PARAMS_DATE_FORMAT  = "DD MMM YYYY";
export const PAYMENT_INTEGRITY_ERROR_CODE  = "134";

export const FETCH_MULTI_SIG_YES = 'Y';
export const FETCH_MULTI_SIG_NO = 'N';